const WORKER_URL = "https://media.secure-hyperhex.workers.dev";

const MB = 1024 * 1024;

const LIMITS = {
  image: 2 * MB,
  video: 20 * MB,
  document: 2 * MB,
};

function detectType(file) {
  if (file.type?.startsWith("image/")) return "image";
  if (file.type?.startsWith("video/")) return "video";
  return "document";
}

export function validateAttachmentFile(file) {
  const type = detectType(file);

  if (type === "image" && file.size > LIMITS.image) {
    return "Image max size is 2MB";
  }
  if (type === "video" && file.size > LIMITS.video) {
    return "Video max size is 20MB";
  }
  if (type === "document" && file.size > LIMITS.document) {
    return "Document max size is 2MB";
  }
  return null;
}

export async function uploadTicketAttachmentToR2(file, meta = {}) {
  const ticketNumber = meta.ticketNumber || "0";
  const ticketTitle = meta.ticketTitle || "ticket";

  const safeTitle = ticketTitle
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "")
    .slice(0, 40);

  const ext = file.name.includes(".")
    ? "." + file.name.split(".").pop()
    : "";

  const storedName =
    `${ticketNumber}-${safeTitle}-${Date.now()}${ext}`;

  const type = detectType(file);
  const folder = `tickets/${type}`;

  const res = await fetch(`${WORKER_URL}/upload`, {
    method: "PUT",
    headers: {
      "Content-Type": file.type,
      "X-File-Name": storedName,
      "X-Folder": folder,
    },
    body: file,
  });

  const data = await res.json();

  if (!res.ok) {
    throw new Error(data?.message || "Upload failed");
  }

  return {
    key: data.key,
    url: data.publicUrl || "",
    type,
    mime: file.type,
    size: file.size,
    storedName,
    originalName: file.name,
  };
}

